import { render, staticRenderFns } from "./braintree.vue?vue&type=template&id=3b0eefa9&"
import script from "./braintree.vue?vue&type=script&lang=js&"
export * from "./braintree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports